import React, { useState } from 'react';
const ContactForm = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    service: '',
    message: ''
  });
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    const {
      name,
      value
    } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // In a real application, you would send this data to a server
    console.log('Form submitted:', formData);
    alert("Thank you for your message. We'll get back to you soon!");
    setFormData({
      name: '',
      email: '',
      phone: '',
      service: '',
      message: ''
    });
  };
  return <form onSubmit={handleSubmit} className="space-y-6" data-id="element-20">
      <div data-id="element-21">
        <label htmlFor="name" className="block text-gray-700 font-medium mb-2" data-id="element-22">
          Full Name
        </label>
        <input type="text" id="name" name="name" value={formData.name} onChange={handleChange} required className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-red-600" placeholder="Your Name" data-id="element-23" />
      </div>
      <div data-id="element-24">
        <label htmlFor="email" className="block text-gray-700 font-medium mb-2" data-id="element-25">
          Email Address
        </label>
        <input type="email" id="email" name="email" value={formData.email} onChange={handleChange} required className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-red-600" placeholder="your.email@example.com" data-id="element-26" />
      </div>
      <div data-id="element-27">
        <label htmlFor="phone" className="block text-gray-700 font-medium mb-2" data-id="element-28">
          Phone Number
        </label>
        <input type="tel" id="phone" name="phone" value={formData.phone} onChange={handleChange} required className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-red-600" placeholder="Your Phone Number" data-id="element-29" />
      </div>
      <div data-id="element-30">
        <label htmlFor="service" className="block text-gray-700 font-medium mb-2" data-id="element-31">
          Service Needed
        </label>
        <select id="service" name="service" value={formData.service} onChange={handleChange} required className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-red-600" data-id="element-32">
          <option value="" data-id="element-33">Select a Service</option>
          <option value="Fire Protection Systems" data-id="element-34">
            Fire Protection Systems
          </option>
          <option value="Underground Leakage Control" data-id="element-35">
            Underground Leakage Control
          </option>
          <option value="Compressed Air Systems" data-id="element-36">Compressed Air Systems</option>
          <option value="HVAC & Chiller Systems" data-id="element-37">HVAC & Chiller Systems</option>
          <option value="Diesel Pump Engines" data-id="element-38">Diesel Pump Engines</option>
          <option value="Plumbing & Mechanical Installations" data-id="element-39">
            Plumbing & Mechanical Installations
          </option>
          <option value="Oil & Gas Mechanical Services" data-id="element-40">
            Oil & Gas Mechanical Services
          </option>
          <option value="Other" data-id="element-41">Other</option>
        </select>
      </div>
      <div data-id="element-42">
        <label htmlFor="message" className="block text-gray-700 font-medium mb-2" data-id="element-43">
          Message
        </label>
        <textarea id="message" name="message" value={formData.message} onChange={handleChange} required rows={5} className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-red-600" placeholder="Tell us about your project or inquiry..." data-id="element-44"></textarea>
      </div>
      <button type="submit" className="bg-red-600 hover:bg-red-700 text-white font-medium py-3 px-6 rounded-md transition-colors w-full" data-id="element-45">
        Send Message
      </button>
    </form>;
};
export default ContactForm;